import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  Sgke081aRequest, Sgke081aResponseDepLstInfo, Sgke082aRequest,
  Sgke082aRequestReginf, Sgke083aRequest, Sgke083aRequestCancelInfo
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke081aService } from '../../services/used-sgke081a.service';
import { UsedSgke082aService } from '../../services/used-sgke082a.service';
import { UsedSgke083aService } from '../../services/used-sgke083a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke080d',
  templateUrl: './sgke080d.component.html',
  styleUrl: './sgke080d.component.scss'
})
export class Sgke080dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 検索結果リスト */
  depLstInfo: Array<Sgke081aResponseDepLstInfo>;

  /** 一覧検索リクエスト */
  private request: Sgke081aRequest;

  /**
   * コンストラクタ
   * @param {UsedSgke081aService} searchService
   * @param {UsedSgke082aService} registService
   * @param {UsedSgke083aService} cancelService
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke080dComponent
   */
  constructor(
    public searchService: UsedSgke081aService,
    public registService: UsedSgke082aService,
    public cancelService: UsedSgke083aService,
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {
  }

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * 初期処理
   */
  ngOnInit(): void {

    // リクエスト情報をもつオブジェクトを定義
    this.request = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
    };

    // 一覧検索を起動
    this.search(this.request);

  }

  /**
   * 最終処理
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 一覧検索処理
   * 
   * @private
   * @param {Sgke081aRequest} request
   * @memberof Sgke080dComponent
   */
  private search(request: Sgke081aRequest) {

    // depLstInfo初期化
    this.depLstInfo = new Array<Sgke081aResponseDepLstInfo>();

    this.searchService.doSgke081a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response) {
          this.depLstInfo = response.shtkInfo?.depLstInfo;
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        }
      },
      error => {
      }
    );
  }

  /**
   * 受付基盤 入金情報照会画面への遷移
   *
   * @param {Sgke081aResponseDepLstInfo} row
   * @memberof Sgke080dComponent
   */
  onDblClickRow(row: Sgke081aResponseDepLstInfo) {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;
    // 入金番号
    let paymentNo: string = row.rcvmnyNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 入金番号
    if (paymentNo) {
      paramToOutside.c__paymentNo = paymentNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '3';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く	
    window.open(`${url}${params}`, '_blank');

  };

  /**
   * 登録ボタン押下処理
   *
   * @param {Sgke081aResponseDepLstInfo[]} selected
   * @memberof Sgke080dComponent
   */
  onClickRegist(selected: Sgke081aResponseDepLstInfo[]): void {

    // エラーメッセージクリア
    this.clearErrorMsg();

    // 登録情報 生成関数
    let requestFunc = function (row: Sgke081aResponseDepLstInfo): Sgke082aRequestReginf {
      return {
        kinkoMno: row.kinkoMno,
        kinkoRrkno: row.kinkoRrkno,
        kinkoUpdateSrno: row.kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: row.kinkoexUpdatesequencenumber,
        kinkoStatuscode: row.kinkoStatuscode,
        funoReason: row.funoReason,
      };
    }

    // 登録リクエストDTO作成
    let sgke082aRequest: Sgke082aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      reginf: selected.map(requestFunc)
    }

    // 登録処理を呼び出し
    this.regist(sgke082aRequest);

  }

  /**
   * 登録処理
   *
   * @private
   * @param {Sgke082aRequest} request
   * @memberof Sgke080dComponent
   */
  private regist(request: Sgke082aRequest) {
    this.registService.doSgke082a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleResponse,
        error => {
        }
      );
  }

  /**
   * 取消ボタン押下処理
   *
   * @param {Sgke081aResponseDepLstInfo[]} selected
   * @memberof Sgke080dComponent
   */
  onClickCancel(selected: Sgke081aResponseDepLstInfo[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 取消情報 生成関数
    let requestFunc = function (row: Sgke081aResponseDepLstInfo): Sgke083aRequestCancelInfo {
      return {
        kinkoMno: row.kinkoMno,
        kinkoRrkno: row.kinkoRrkno,
        kinkoUpdateSrno: row.kinkoUpdateSrno,
        kinkoexUpdatesequencenumber: row.kinkoexUpdatesequencenumber,
        kinkoStatuscode: row.kinkoStatuscode,
      };
    }

    // 取消リクエストDTO作成
    let sgke083aRequest: Sgke083aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      cancelInfo: selected.map(requestFunc)
    }

    // 取消処理を呼び出し
    this.cancel(sgke083aRequest);

  }

  /**
   * 取消処理
   *
   * @private
   * @param {Sgke083aRequest} request
   * @memberof Sgke080dComponent
   */
  private cancel(request: Sgke083aRequest) {
    this.cancelService.doSgke083a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleResponse,
        error => {
        }
      );
  }

  /**
   * エラーメッセージ表示領域をクリア
   *
   * @private
   * @memberof Sgke080dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response 
   * @memberof Sgke080dComponent
   */
  private handleResponse = (response: any): void => {
    if (response) {
      // メッセージを表示
      this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      // 一覧を再検索
      this.search(this.request);
    }
  }

}
